var textfarbe='#ffdd00';
var textColor='#000000';

$(document).ready(function() {
    $('area').live('mouseover',function(e) {

        e.stopPropagation();
        var clicked = e.target;

        var classArray=textColor.split('_');
        textfarbe=classArray[0];

        var country = $(clicked).attr('class');
        country_mouseover(country);
    }).live('mouseout',function(e) {
        var clicked = e.target;
        var country = $(clicked).attr('class');
        country_mouseout(country);
    });

    $(document).on('mouseover mouseout', '.sm_bgd', function(e) {
        if(e.type === 'mouseover'){
            e.stopPropagation();

            let hovered = e.target;

            $(hovered).addClass("cursor_hand");
            let dataElement = $(hovered).closest('[rel]');

            if (dataElement) {
                var country = dataElement.attr('rel').replace(' ','_');
                textColor = dataElement.attr('fel');
                var classArray=textColor.split('_');
                textfarbe=classArray[0];

                country_mouseover(country);
            }
        } else if(e.type === 'mouseout'){
            let hovered = e.target;
            let dataElement = $(hovered).closest('[rel]');
            if (dataElement) {
                var country = dataElement.attr('rel').replace(' ', '_');
                country_mouseout(country);
            }
        }
    });
});

function country_mouseover(country) {
    var classArray=country.split('_');
    var color=classArray[0];

    $('a.qty_minus').attr('rel',country);
    $('a.qty_plus').attr('rel',country);
    $('.products_qty').attr('rel',country);
    $('a.qty_minus').attr('fel',textfarbe);
    $('a.qty_plus').attr('fel',textfarbe);
    $('.products_qty').attr('fel',textfarbe);
    $('#'+country+'_hover').show();
    color = color.replace('_',' ');

    var new_color =  hexToRgb('#'+color);

    $('section.'+country).css('background-color', 'rgba('+new_color+', 1)');
    $('span.'+country+' ').css('color','#'+color);
}

function country_mouseout(country) {
    $('#'+country+'_hover').hide();
    $('section.'+country).css('background-color', '');
    $('span.'+country+' ').css('color','');
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ?
    parseInt(result[1], 16)+','+parseInt(result[2], 16)+','+parseInt(result[3], 16)
        : null;
}
